import * as React from 'react';
import { SVGProps } from 'react';

const IconLayersSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.424 1.099a1 1 0 0 0-.848 0L1.223 3.138a.4.4 0 0 0 0 .724l4.438 2.079a.8.8 0 0 0 .678 0l4.438-2.079a.4.4 0 0 0 0-.724l-4.353-2.04z" />
    <path d="m2.051 5.25-.828.388a.4.4 0 0 0 0 .724l4.438 2.079a.8.8 0 0 0 .678 0l4.438-2.079a.4.4 0 0 0 0-.724l-.828-.388-3.61 1.69a.8.8 0 0 1-.678 0L2.05 5.25z" />
    <path d="m2.051 7.75-.828.388a.4.4 0 0 0 0 .724l4.438 2.079a.8.8 0 0 0 .678 0l4.438-2.079a.4.4 0 0 0 0-.724l-.828-.388-3.61 1.69a.8.8 0 0 1-.678 0L2.05 7.75z" />
  </svg>
);
export default IconLayersSizeXs;
